import React from 'react';
import { CategoryLink } from '../../../form-elements/Link';

function SubNavbar({ subCategory, index }) {
    return (
        <>
            <li key={index}>
                <CategoryLink category={subCategory}>{subCategory.title}</CategoryLink>
            </li>
        </>
    );
}

export default SubNavbar;
